import {  } from './paths'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { } from '../Screens'
import {  } from '../Components'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const Routing = () => {

    return (
        <>
            <Router>
                <Switch>
                    {/* <Route path={HOME} exact component={(props) => <Home {...props} user={user} locations={locations} allUser={allUser} getAllUsers={getAllUsers} />} /> */}
                </Switch>
            </Router>
        </>
    )
}
export { Routing }
